import { Ambiente } from '../../types';
import { ElegibilidadeWidgetAvaliacaoConfig, Params } from './elegibilidade-widget-avaliacao.types';

const configDefault: ElegibilidadeWidgetAvaliacaoConfig = {
  blocklist: [{ marca: 'idomed' }],
};

const configsPorAmbiente: Record<Ambiente, ElegibilidadeWidgetAvaliacaoConfig> = {
  dev: { ...configDefault },
  prd: configDefault,
  hml: configDefault,
  local: { ...configDefault },
};

export const getElegibilidadeWidgetAvaliacaoConfig = ({ ambiente }: Params): ElegibilidadeWidgetAvaliacaoConfig =>
  configsPorAmbiente[ambiente];
